import React from "react"
import { Link } from "gatsby"
import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import "../../../styles/industry.scss"
import linkedIn from "../../../assets/images/linkedIn.svg"
import messenger from "../../../assets/images/messenger.svg"
import readmoreImg from "../../../assets/images/readmoreImg.svg"
import lucrys from "../../../assets/images/lucrys.png"
import iig from "../../../assets/images/iig.jpg"
import jsplObj from "../../../assets/images/jspl-obj.png"
import jsplSol from "../../../assets/images/jspl-sol.jpg"
import acuteSingleProdImg from "../../../assets/images/single-product-acute-image.png"

const Jspl = () => (
  <Layout>
    <SEO title="JSPL" />

    <div className="row industry-banner text-center m-0">
      <div className="col-12 white">
        <h5>Steel Manufacturing Industry</h5>
        <h1>Enhance Process Efficiency through AI algorithms</h1>
      </div>
    </div>

    <br />
    <div className="container">
      <div className="text-center">
        <h3 className="title">Introduction</h3>
        <p className="title-text">
          Jindal Steel & Power Limited used our Lucrys Analytics Platform to
          connect their machines, track and improve the deviations in the
          manufacturing process on a real-time basis.
        </p>
        <p className="read-more pt-2" style={{ color: "#202020" }}>
          JSPL is an industrial powerhouse with a dominant presence in the
          steel, power, mining, and infrastructure sectors. Part of the US $ 22
          billion OP Jindal Group, the Company is continuously scaling its
          capacity utilizations and efficiencies to capture opportunities for
          Building A Nation of Our Dreams.
        </p>
      </div>
      <br />
      <div className="pt-4">
        <h4 className="pt-lg-4 pt-md-2 px-0 mb-lg-0 sub-title">
          Their Objective
        </h4>
        <div className="row m-0 text-left">
          <div className="col-12 col-lg-6 col-md-6 text-center p-0 order-lg-2 order-md-2">
            <div className="industry-img">
              <img src={jsplObj} className=" responsive-img" />
            </div>
          </div>
          <div className="col-12 col-lg-6 col-md-6 pl-0 pr-0 pr-lg-5 pr-md-3 order-lg-1 order-md-1">
            <p className="pt-4 pt-lg-0 pt-md-0 read-more">
              JSPL was unable to track and locate deviations in the
              manufacturing process accurately. This inability could potentially
              mean the loss of essential and high-value clients and market
              reputation.
            </p>
            <p className="pt-lg-3 read-more">
              Their deviation management process had many standard components.
              Collecting data manually isn't optimal as such information isn't
              always reliable. It can be a nightmare to manually track and
              monitor every step in a complex manufacturing process, such as
              theirs.
            </p>
            <p className="pt-lg-3 read-more">
              JSPL approached us to introduce industrial automation and
              digitization in their manufacturing process. This transformation
              would help them closely monitor critical manufacturing details and
              parameters in real-time.
            </p>
          </div>
        </div>
      </div>
      <div className="pt-4">
        <h4 className="my-3 my-lg-5 py-3 py-md-2 py-lg-3 title text-center">
          Our Solution
        </h4>
        <div className="row m-0 text-left">
          <div className="col-12 col-lg-6 col-md-6 text-center p-0 order-lg-2 order-md-2">
            <div className="industry-img">
              <img src={jsplSol} className="responsive-img" />
            </div>
          </div>
          <div className="col-12 col-lg-6 col-md-6 pl-0 pr-0 pr-lg-5 pr-md-3 order-lg-1 order-md-1">
            <p className="pt-4 pt-lg-0 pt-md-0 read-more">
              We began installing our integrated industrial gateways on their
              assets and connected them to our Lucrys Analytics system.
            </p>
            <p className="pt-lg-1 read-more">
              During the steel manufacturing process, once the molten steel
              strands come out on the rollers, it's almost impossible to
              manually verify the end product's raw-material composition.
              Additionally, manually differentiating between strands of
              different heat numbers and sequence numbers can be frustrating.
            </p>
            <p className="pt-lg-1 read-more">
              Our algorithm tracked every minute detail of their production
              process from start to finish. This precise tracking enabled the
              real-time identification of deviations at any point throughout the
              process. Additionally, the users could also monitor whether all
              parameters are always within acceptable limits.
            </p>
            <p className="pt-lg-1 read-more">
              Once our AI platform identifies anomalies in the process, the
              system relays any changes in these values to the operators. They
              then immediately intervene and alter the process parameters in
              real-time to ensure agreed quality and proper steel production.
            </p>
            <p className="pt-lg-1 read-more">
              Additionally, such an automated and reliable system allows JSPL
              always to substantiate and prove their dedication to quality and
              customer obligation.
            </p>
            {/* <p className="pt-lg-1 read-more">
                        Additionally, such an automated and reliable system allows JSPL always to substantiate and
                        prove their dedication to quality and customer obligation.
                    </p> */}
          </div>
        </div>
      </div>
    </div>
    <div className="m-0 py-5">
      <div className="pb-lg-5 results-div">
        <div className="text-center">
          <h2 className="title">Results</h2>
          <h3 className="col-lg-8 offset-lg-2 col-md-10 offset-md-1">
            This accurate prediction allowed Chemicals Ltd to prevent downtime
            of 12 hours.
          </h3>
        </div>
        <div className="container">
          {/* <div className="row m-0 pl-lg-0 pl-md-0">
                        <div className="col-lg-7 p-0 col-md-12"> */}
          <div className="px-0 pt-3 pt-lg-5 pb-3 pb-md-5 pt-md-4 col-lg-5 col-md-4 results-desc">
            <p className="read-more text-left">
              And that is not all. When JSPL compared the amount invested in
              our products and their savings in downtime costs, they found the
              ROI to be ten times their investment in Machstatz!
            </p>
            <p className="read-more text-left">
              This way, we accurately predicted what component caused the
              recurring shutdowns, but we also identified why the part failed
              frequently. We removed costly guesswork and replaced it with an
              intelligent system that consistently warns them about imminent
              issues.
            </p>
          </div>
          {/* </div>
                    </div> */}
        </div>
      </div>
    </div>
    <div className="container mt-5 mb-5 100vh">
      <h4 className="text-center title">Products Used</h4>
      <div className="row text-center pt-3 pt-lg-5 pb-3 pb-lg-5 mx-0">
        <div className="col-12 col-lg-6 p-0 pr-md-3">
          <div className="w-100 prod-div d-flex flex-column">
            <Link
              to="/integrated-industrialized-gateways"
              className="flex-fill"
            >
              {/* <div className="prod-image-wrapper"> */}
              <div className="prod-img">
                <img src={iig} className="responsive-img" />
              </div>
              {/* </div> */}
            </Link>
            <h3 className="text-center sub-title-prod">
              Integratred Industrial Gateway
            </h3>
          </div>
        </div>
        <div className="col-12 col-lg-6 mt-5 mt-lg-0 p-0 pl-lg-3 ">
          <div className="prod-div d-flex flex-column">
            <Link
              to="/integrated-industrialized-gateways"
              className="flex-fill"
            >
              {/* <div className="prod-image-wrapper"> */}
              <div className="prod-img">
                <img src={lucrys} className="responsive-img" />
              </div>
              {/* </div> */}
            </Link>
            <h3 className="text-center sub-title-prod">Lucrys Analytics</h3>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div className="row m-0">
      <div className="sol-div col-lg-12 col-md-12 text-center">
        <h4 className="bold sub-title">Solution Used</h4>
        <img className="industry-soln" src={acuteSingleProdImg} />
        <h4 className="bold sub-title" style={{ fontFamily: "Avenir Roman" }}>
          Acute
        </h4>
      </div>
    </div>
    <br />
    <div className="container">
      {/* <div className="text-center d-flex blog-share pl-lg-3 px-lg-3">
                <span className="font-14 bold blog-share-text order-md-3 py-2 py-md-0">
                    Don't forget to share this post!
            </span>
                <div className="blog-share-icons">
                    <i className="fab fa-facebook-f share-icon"></i>
                    <i className="fab fa-linkedin-in share-icon"></i>
                    <i className="fab fa-twitter share-icon"></i>
                    <i className="fab fa-facebook-messenger"></i>
                </div>
                <span className="font-25 flex-fill px-1 d-none d-md-block">
                    <span className="blog-dashed-lines"></span>
                </span>
            </div> */}
      <div className="d-flex align-items-center flex-wrap">
        <div className="order-md-3 share-request-text-for-particular">
          <p className="pl-md-2 m-0 text-center">
            Don't forget to share this post!
          </p>
        </div>
        <div className="share-icons pr-md-2 text-center mt-3 mt-lg-0 mt-md-0">
          <a
            className="share-icon"
            target="_blank"
            href="https://www.facebook.com/sharer/sharer.php?u=https://machstatz.com/jspl"
          >
            <img
              className="icons-for-particular"
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUgMUMxMS42ODYzIDEgOSAzLjY4NjI5IDkgN1Y5SDdDNi40NDc3MiA5IDYgOS40NDc3MSA2IDEwVjE0QzYgMTQuNTUyMyA2LjQ0NzcyIDE1IDcgMTVIOVYyMkM5IDIyLjU1MjMgOS40NDc3MiAyMyAxMCAyM0gxNEMxNC41NTIzIDIzIDE1IDIyLjU1MjMgMTUgMjJWMTVIMTdDMTcuNDU4OSAxNSAxNy44NTg5IDE0LjY4NzcgMTcuOTcwMSAxNC4yNDI1TDE4Ljk3MDEgMTAuMjQyNUMxOS4xMjc5IDkuNjExMzkgMTguNjUwNiA5IDE4IDlIMTVWN0gxOEMxOC41NTIzIDcgMTkgNi41NTIyOCAxOSA2VjJDMTkgMS40NDc3MiAxOC41NTIzIDEgMTggMUgxNVpNMTUgM0gxN1Y1SDE1QzEzLjg5NTQgNSAxMyA1Ljg5NTQzIDEzIDdWMTBDMTMgMTAuNTUyMyAxMy40NDc3IDExIDE0IDExSDE2LjcxOTJMMTYuMjE5MiAxM0gxNEMxMy40NDc3IDEzIDEzIDEzLjQ0NzcgMTMgMTRWMjFIMTFWMTRDMTEgMTMuNDQ3NyAxMC41NTIzIDEzIDEwIDEzSDhWMTFIMTBDMTAuNTUyMyAxMSAxMSAxMC41NTIzIDExIDEwVjdDMTEgNC43OTA4NiAxMi43OTA5IDMgMTUgM1oiIGZpbGw9ImJsYWNrIi8+DQo8bWFzayBpZD0ibWFzazAiIG1hc2stdHlwZT0iYWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjYiIHk9IjEiIHdpZHRoPSIxNCIgaGVpZ2h0PSIyMiI+DQo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1IDFDMTEuNjg2MyAxIDkgMy42ODYyOSA5IDdWOUg3QzYuNDQ3NzIgOSA2IDkuNDQ3NzEgNiAxMFYxNEM2IDE0LjU1MjMgNi40NDc3MiAxNSA3IDE1SDlWMjJDOSAyMi41NTIzIDkuNDQ3NzIgMjMgMTAgMjNIMTRDMTQuNTUyMyAyMyAxNSAyMi41NTIzIDE1IDIyVjE1SDE3QzE3LjQ1ODkgMTUgMTcuODU4OSAxNC42ODc3IDE3Ljk3MDEgMTQuMjQyNUwxOC45NzAxIDEwLjI0MjVDMTkuMTI3OSA5LjYxMTM5IDE4LjY1MDYgOSAxOCA5SDE1VjdIMThDMTguNTUyMyA3IDE5IDYuNTUyMjggMTkgNlYyQzE5IDEuNDQ3NzIgMTguNTUyMyAxIDE4IDFIMTVaTTE1IDNIMTdWNUgxNUMxMy44OTU0IDUgMTMgNS44OTU0MyAxMyA3VjEwQzEzIDEwLjU1MjMgMTMuNDQ3NyAxMSAxNCAxMUgxNi43MTkyTDE2LjIxOTIgMTNIMTRDMTMuNDQ3NyAxMyAxMyAxMy40NDc3IDEzIDE0VjIxSDExVjE0QzExIDEzLjQ0NzcgMTAuNTUyMyAxMyAxMCAxM0g4VjExSDEwQzEwLjU1MjMgMTEgMTEgMTAuNTUyMyAxMSAxMFY3QzExIDQuNzkwODYgMTIuNzkwOSAzIDE1IDNaIiBmaWxsPSJ3aGl0ZSIvPg0KPC9tYXNrPg0KPGcgbWFzaz0idXJsKCNtYXNrMCkiPg0KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJibGFjayIvPg0KPC9nPg0KPC9zdmc+DQo="
            ></img>
          </a>
          <a
            className="share-icon"
            target="_blank"
            href="https://www.linkedin.com/shareArticle?mini=true&url=https://machstatz.com/jspl&title=Jindal Steel & Power Limited uses our Lucrys analytics&source=JSPL with Machstatz"
          >
            <img className="icons-for-particular" src={linkedIn}></img>
          </a>
          <a
            className="share-icon"
            target="_blank"
            href="https://twitter.com/intent/tweet?text=https://machstatz.com/jspl"
          >
            <img
              className="icons-for-particular"
              src="data:image/svg+xml;base64,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"
            ></img>
          </a>
          {/* <a className="share-icon" target="_blank" href="https://www.messenger.com/machstatz/">
                        <img className="icons" src={messenger}></img>
                    </a> */}
        </div>
        <div className="share-dashes d-none d-md-block"></div>
      </div>
      <br />
      <div className="industry-scroller row pt-3 pt-lg-5 ml-0">
        <div className="col-12 col-lg-6 col-md-6">
          <div className="pl-3 p-md-0">
            <div className="speech-bubble-story-1">
              <p className="questions">
                Stanzen Engineering increased the operational efficiency of
                their entire plan by 30% using our Industrial IoT Gateways and
                Lucrys Analytics.
              </p>
              <Link to="/case-studies/stanzen">
                <p className="pl-4 d-flex">
                  <img className="icons" src={readmoreImg}></img>
                  <p className="read-more-speech pl-2 float-l">Read more</p>
                </p>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 offset-lg-0 col-md-6 pl-0 pl-md-5">
          <div className="p-md-0">
            <div className="speech-bubble-story-2">
              <p className="questions">
                A Chemical Manufacturing Plant successfully predicted and
                prevented 12 hours of machine downtime using pattern recognition
                and AI (a 10x ROI!)
              </p>
              <Link to="/case-studies/kmml">
                <p className="pl-4 d-flex">
                  <img className="icons" src={readmoreImg}></img>
                  <p className="read-more-speech pl-2 float-l">Read more</p>
                </p>
              </Link>
            </div>
          </div>
        </div>
        {/* <div className="col-lg-4 col-md-12">
                    <div className="p-md-0 text-center">
                        <div className=" speech-bubble-industry-3">
                            <p className="questions font-12 p-0">
                                text unknown text unknown text unknown text unknown text unknown text unknowntext unknown text
                    </p>
                            <p className="p-0 d-none d-lg-block">
                                <i className="fas fa-arrow-circle-right read-more float-l">Read more</i>
                            </p>
                        </div>
                    </div>
                </div> */}
      </div>
    </div>
  </Layout>
)

export default Jspl
